import React from 'react';
import { connect } from 'react-redux';
import { Form, Control, actions } from 'react-redux-form';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import BaseDetailScreen from '../../BaseDetailScreen';
import Button from '../../Button';
import InputField from '../../Forms/Controls/Field';
import { baseForgotPwdPath } from '../../Forms/Schemas/baseRrf';
import { validateEmail } from '../../Forms/Validators';
import { requestResetCredentials } from '../../../actions';
import { addNotification } from '../../../actions/notifications';

import blueCheck from '../../../assets/images/blue_confirmation_check.png';

import './styles.css';
import imgWarning from '../../../assets/images/warning.svg';
import logo from '../../../assets/images/logo.svg';

const EmailRequested = ({ email }) => (
  <div styleName="successContainer">
    <img
      src={blueCheck}
      alt="Checkmark"
      styleName="successCheck"
    />
    <div styleName="confirmationText">
      If the email address you entered is found in our system, a password reset link will be sent to
    </div>
    <div styleName="confirmationEmail">
      { email }
    </div>
  </div>
);

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      accountReviewOrLocked: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit() {
    if (!this.state.submitting) {
      this.setState({ submitting: true });
    } else {
      return;
    }

    try {
      await this.props.requestResetCredentials(this.props.email);
      this.setState({ sent: true, submitting: false });
    } catch (err) {
      this.setState({ submitting: false });
      const { error } = await err.res.json();
      if (error && error.message === 'Account Locked') {
        this.setState({ accountReviewOrLocked: true });
        return;
      }
      if (error && error.message === 'ssn-required') {
        this.props.addNotification('Due to several failed login attempts your account is under review and a password ' +
          'reset is not possible at this time. Please follow up on your email inbox.');
        this.props.history.push('/login');
        return;
      }
      this.props.setRequestError(err.message);
    }
  }

  render() {
    const buttonText = this.state.submitting ? 'Sending' : 'Send';
    const inputProps = {
      model: '.email',
      RRFComp: Control.text,
      control: {
        mapProps: {
          placeholder: 'Email',
          type: 'email',
        },
        onChange: (val) => {
          this.props.setRequestError('');
          this.props.updateVal(val);
        },
        errors: {
          required: val => !val || !val.length,
          isEmail: val => val && !validateEmail(val),
        },
      },
      error: {
        messages: {
          required: 'Please provide your email address.',
          isEmail: val => `${val} is not a valid Email Address`,
        },
      },
    };
    let content = (
      <BaseDetailScreen
        backLabel="Log In"
        backTo="/login"
        pageHeadeing="Forgot Password"
      >
        <div styleName="main">
          { this.state.sent ?
            <EmailRequested email={this.props.email} /> :
            (
              <Form
                model={baseForgotPwdPath}
                onSubmit={this.onSubmit}
              >
                <div styleName="explainText">
                  We&apos;ll send you a link to reset your password
                </div>
                <div styleName="emailInput">
                  <InputField
                    key={inputProps.model}
                    fieldProps={inputProps}
                  />
                </div>
                <div styleName="submitButtonContainer">
                  <Button
                    type="submit"
                    disabled={this.state.submitting}
                  >
                    { buttonText }
                  </Button>
                </div>
              </Form>
            )
          }
        </div>
      </BaseDetailScreen>
    );
    if (this.state.accountReviewOrLocked) {
      content = (
        <div>
          <Link to="/">
            <img
              src={logo}
              alt="My IPO"
              styleName="logo"
            />
          </Link>
          <div styleName="alertBody">
            <div styleName="alertRow">
              <img src={imgWarning} alt="Warning" styleName="alertImg" style={{ width: 120, height: 120 }} />
            </div>
            <div styleName="alertRow">
              <div styleName="alertRed">
                Account Locked
              </div>
            </div>
            <div styleName="alertRow">
              <div styleName="alertMessage">
                To unlock your account please contact&nbsp;
                <a styleName="alertLink" href="mailto:clientservices@myipo.com">
                  clientservices@myipo.com
                </a>
                &nbsp;for further details.&nbsp;
              </div>
            </div>
          </div>
        </div>
      );
    }
    return content;
  }
}

const mapStateToProps = state => ({
  email: get(state, 'forgotPwdForm.email'),
});

const mapDispatchToProps = dispatch => ({
  requestResetCredentials: email => (dispatch(requestResetCredentials(email))),
  setRequestError: error => (dispatch(actions.setErrors(`${baseForgotPwdPath}.email`, {
    failedRequest: error,
  }))),
  updateVal: val => (dispatch(actions.change(`${baseForgotPwdPath}.email`, val))),
  addNotification: (...args) => (dispatch(addNotification(...args))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ForgotPassword/index.js